export const listPrazos = [
  { label: "Prazos...", value: null, disabled: true },
  { label: "Até 10 dias", value: "ate-10-dias" },
  { label: "Contínua (Indeterminada)", value: "sem-prazo" },
  { label: "Entre 10 e 30 dias", value: "entre-10-e-30-dias" },
  { label: "Mais de 30 dias", value: "mais-de-30-dias" },
];
